import React from "react";
import { useNav } from "../customHooks/useNav";
import "./Page.css";

const About = () => {
  const aboutRef = useNav("Over mij");

  return (
    <section ref={aboutRef} id="aboutContainer">
      <div className="section-inner about-grid">
        <div>
          <div className="numbered-label">01</div>
          <h2 className="about-heading">Over mij</h2>
          <p className="about-sub">
            Afgestudeerd in <span className="highlight">Information Science</span> ·
            werkzaam als <span className="highlight">Scientist</span>
          </p>
        </div>
        <div className="about-body">
          <p>
            Ik ben iemand die graag dingen zelf uitzoekt en goed zelfstandig kan
            werken. Mensen omschrijven mij als rustig, betrouwbaar, ambitieus en
            een harde werker.
          </p>
          <p className="about-sub">
            Binnen de IT heb ik verschillende interesses en ook ervaring met
            verschillende takken van sport. Zo heb ik me tijdens mijn studie
            voornamelijk op Machine Learning gefocust, terwijl ik mijn
            eerdere werkervaring hoofdzakelijk heb opgedaan in Backend Development.
            Momenteel hou ik me bezig als Scientist met de technische kant van datadeelinfrastructuur, inclusief maar niet gelimiteerd tot <span className="highlight">fullstack development</span> en <span className="highlight">Kubernetes</span>. Mijn hobby's zijn hardlopen,
            wandelen in de natuur, (board)gamen en afspreken met vrienden.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
